const LEVEL_INDENT_PX = 14;
// La freccetta occupa diciotto pixel, non un tasto intero (utente, 2026-10-15): meno vuoto a sinistra.
export const COMPOSER_CHEVRON_SLOT_PX = 18;
const CHEVRON_SLOT_PX = COMPOSER_CHEVRON_SLOT_PX;

export const getComposerAttributeIndent = (level: number): number => level * LEVEL_INDENT_PX;

/** Leaves have no chevron, but must start to the right of their parent attribute. */
export const getComposerLeafIndent = (attributeLevel: number): number => getComposerAttributeIndent(attributeLevel + 1) + CHEVRON_SLOT_PX;
